
(function(c){var d=document,a='appendChild',i='styleSheet',s=d.createElement('style');s.type='text/css';d.getElementsByTagName('head')[0][a](s);s[i]?s[i].cssText=c:s[a](d.createTextNode(c));})
('.dcf-popup-content{-webkit-transition:opacity 125ms cubic-bezier(.25,.46,.45,.94);transition:opacity 125ms cubic-bezier(.25,.46,.45,.94)}');
